<template>
  <div style="display: flex;">
    <span class="breadcrump" v-for="(item, index) in breadcrumb">
      <span :class="[(index === breadcrumb.length - 1) ? 'tela-atual' : undefined]">
        {{ item }}
      </span>

      <span class="px-1" v-if="index !== breadcrumb.length - 1">
        <v-icon size="15">$CaretRight</v-icon>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: { breadcrumb: { type: Array, required: true } }
}
</script>

<style scoped>
.breadcrump {
  font-size: 14px;
  color: #39404B;
  font-weight: 400;
}

.tela-atual {
  color: #4075FF;
  background-color: #ECF1FF;
  padding: 6px 10px;
  border-radius: 4px;
  font-weight: 400;
  margin-left: 5px;
}
</style>
